import { z } from 'zod/v4';
const permissionsSchema = z.object({
    on_demand_updates: z.boolean(),
    unlimited_domains: z.boolean(),
    customer_support: z.boolean(),
    api_access: z.boolean(),
    unlimited_add_ons: z.boolean(),
    share_of_voice: z.boolean(),
    serp_history: z.boolean(),
    mobile_tracking: z.boolean(),
    spyglass: z.boolean(),
    suggestions: z.boolean(),
    search_intent: z.boolean(),
    serp_features: z.boolean(),
    custom_alerts: z.boolean(),
    local_rank_tracking: z.boolean(),
    viewkey_reports: z.boolean(),
    custom_viewkey_domain: z.boolean(),
    scheduled_reports: z.boolean(),
    google_integrations: z.boolean(),
    dashthis_integration: z.boolean(),
});
export const pkgSchema = z.object({
    title: z.string(),
    name: z.string(),
    package_identity: z.string(),
    plan_type: z.literal('addon').nullable(),
    active: z.number(),
    price: z.number(),
    price_by_coupon: z.number(),
    annual_price: z.number(),
    annual_price_by_coupon: z.number(),
    cycle: z.enum(['daily', 'weekly']),
    on_demand_updates: z.number(),
    keywords_tracked: z.number(),
    permissions: permissionsSchema,
});
